import { Avatar, Tooltip, Card, CardContent, Typography, Stack, Chip, IconButton } from "@mui/material";
import ForumOutlinedIcon from "@mui/icons-material/ForumOutlined";
import { labelOrigenOportunidad, esOrigenOportunidadValido } from "./expansionConstants";
import { senalesOportunidad } from "./expansionMetrics";

export default function ExpansionCard({ opp, store, moneda, onDragStart, onDragEnd, isDragging, onClick, onSeguimiento }) {
  const lead = store.leads.find((l) => l.id === opp.leadId);
  const vendedor = store.config.vendedores.find((v) => v.id === opp.vendedorId)?.nombre;
  const asignado = store.config.vendedores.find(v => v.id === lead?.vendedorId);
  const senales = senalesOportunidad(opp, { diasEstancamiento: store.config.diasEntreSeguimiento || 7 });
  const monto = Number(opp.montoEstimado) > 0
    ? `${moneda} ${Number(opp.montoEstimado).toLocaleString()}`
    : "Sin estimar";

  return (
    <Card
      variant="outlined"
      draggable
      onDragStart={onDragStart}
      onDragEnd={onDragEnd}
      onClick={onClick}
      sx={{
        cursor: "grab",
        opacity: isDragging ? 0.5 : 1,
        borderColor: senales.length ? "warning.light" : "divider",
        "&:hover": { borderColor: "primary.light" },
      }}
    >
      <CardContent sx={{ p: 1.25, "&:last-child": { pb: 1.25 } }}>
        {asignado && <Tooltip title={`Asignado a ${asignado.nombre}`}><Avatar sx={{ width: 24, height: 24, fontSize: 12, bgcolor: asignado.color || '#555', color: '#fff' }}>{asignado.nombre?.[0]?.toUpperCase()}</Avatar></Tooltip>}
        <Typography variant="caption" color="text.secondary" fontWeight={600}>{lead?.nombre || "Cliente"}</Typography>
        <Typography variant="body2" fontWeight={700} noWrap>{opp.nombre}</Typography>
        <Typography variant="body2" color="success.dark" fontWeight={600}>{monto}</Typography>
        {opp.origen && esOrigenOportunidadValido(opp.origen) && (
          <Typography variant="caption" color="text.secondary" display="block" noWrap>
            {labelOrigenOportunidad(opp.origen)}
          </Typography>
        )}
        {opp.fechaCierreEsperada && <Typography variant="caption" display="block">Cierre esperado: {opp.fechaCierreEsperada}</Typography>}
        {opp.motivoPerdida && opp.etapa === "perdida" && <Typography variant="caption" display="block">Pérdida: {opp.motivoPerdida}</Typography>}
        {opp.proximaAccion && (
          <Typography variant="caption" display="block" noWrap sx={{ mt: 0.5 }}>{opp.proximaAccion}</Typography>
        )}
        <Stack direction="row" justifyContent="space-between" alignItems="center" mt={0.5}>
          <Typography variant="caption" color="text.secondary">
            {opp.proximoSeguimiento ? opp.proximoSeguimiento.slice(5) : "—"}
          </Typography>
          <Stack direction="row" alignItems="center" spacing={0.25}>
            {onSeguimiento && (
              <IconButton
                size="small"
                aria-label="Seguimiento"
                onClick={(e) => { e.stopPropagation(); onSeguimiento(); }}
                sx={{ p: 0.25 }}
              >
                <ForumOutlinedIcon sx={{ fontSize: 16 }} />
              </IconButton>
            )}
            <Typography variant="caption" color="text.secondary">{vendedor || "—"}</Typography>
          </Stack>
        </Stack>
        {senales.length > 0 && (
          <Chip size="small" label={senales[0].replace(/_/g, " ")} sx={{ mt: 0.5, height: 18, fontSize: 10 }} />
        )}
      </CardContent>
    </Card>
  );
}
